exports.f = require('./_wks');



/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/modules/_wks-ext.js
 ** module id = 2207
 ** module chunks = 3
 **/